import { useTranslation } from 'hooks';
import { FormLayout } from '../components/FormLayout';
import Input from 'components/ui/input';
import { NewButton as Button } from '../components/NewButton';

interface Props {
  email: string;
  validation: any;
  settings: any;
  onChange: any;
  onReset: () => void;
  goBack: () => void;
}

export const PasswordResetForm: React.FC<Props> = ({
  email,
  settings,
  validation,
  goBack,
  onChange,
  onReset,
}) => {
  const getTranslate = useTranslation();

  return (
    <>
      <FormLayout
        title='auth.reset.header'
        text='auth.reset.text'
        body={
          <Input
            id='email'
            label={getTranslate('auth.email.label')}
            placeholder={getTranslate('auth.email.placeholder')}
            value={email}
            onChange={(event) => onChange('email', event.target.value)}
            error={validation && validation.email}
            modern
          />
        }
        submitButton={
          <Button disabled={!email} type='submit'>
            {getTranslate('auth.reset.button')}
          </Button>
        }
        onSubmit={() => {
          if (email) {
            onReset();
          }
        }}
        onReturn={goBack}
      />

      <div className='form-layout__link'>
        <a href={`mailto:${settings.supportEmail}`} className='utils-link'>
          {getTranslate('auth.contact.link')}
        </a>
      </div>
    </>
  );
};
